// react
import React, { Component,Fragment } from 'react';

// router
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import {TodoProvider} from '../store/todoContext';


//  bootstrap css
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// react pages
import Header from './layout/header';
import Footer from './layout/footer';

import Home from './pages/home';
import About from './pages/about';

class App extends Component {
  render() {
    return (
      <TodoProvider>
        <Router>
          <Fragment>

            <Header branding="ToDo" />

            <div className="container">
              <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/about" component={About} />
                <Route  component={Home} />
              </Switch>
            </div>

            <Footer />

          </Fragment>
        </Router>
      </TodoProvider>
    )
  }
}
export default App;
